import FireIcon from '../DailyStreakView/FireIcon'

import { getOfferProgress, getOfferStreak } from './offerRewards'

const SIZE = 56
const STROKE = 5
const RADIUS = (SIZE - STROKE) / 2
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

/**
 * A game in progress: its icon, the ring filling with the progress of the whole offer, and
 * the streak the offer is on.
 *
 * The two say different things on purpose: the ring is the offer, the flame is the streak.
 * An offer with no milestones shows an empty ring, and one with no streak task shows no flame.
 */
const ActiveOfferAvatar = ({ offer, size = SIZE, stackOrder }) => {
  const offerProgress = getOfferProgress(offer.activatedOffer)
  const streak = getOfferStreak(offer.activatedOffer)
  const scale = size / SIZE

  return (
    <span className="gamesRedesignAvatar" style={{ width: size, height: size, zIndex: stackOrder }}>
      <svg
        className="gamesRedesignAvatarRing"
        width={size}
        height={size}
        viewBox={`0 0 ${SIZE} ${SIZE}`}
      >
        <defs>
          <linearGradient id="gamesRedesignOfferRing" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FF6492" />
            <stop offset="1" stopColor="#FFA906" />
          </linearGradient>
        </defs>
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="white"
          stroke="#CFCDCD"
          strokeWidth={STROKE}
        />
        {offerProgress?.progress > 0 && (
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke="url(#gamesRedesignOfferRing)"
            strokeWidth={STROKE}
            strokeLinecap="round"
            strokeDasharray={`${CIRCUMFERENCE * offerProgress.progress} ${CIRCUMFERENCE}`}
            transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            data-testid="offer-progress-ring"
          />
        )}
      </svg>
      <img className="gamesRedesignAvatarIcon" src={offer.iconUrl} alt="" />
      {streak && (
        <span className="gamesRedesignAvatarStreak">
          <FireIcon
            type={streak.days > 0 ? 'enabled' : 'disabled'}
            width={Math.round(26 * scale)}
            value={streak.days}
            avoidBoldText
          />
        </span>
      )}
    </span>
  )
}

export default ActiveOfferAvatar
